<template>
  <div @click="goToHealthyList">
    <ChartBox title="健康证展示" more="更多">
      <div v-if="!healthList.length > 0">
        <img
          style="height: 232px; width: 100%"
          src="./../assets/image/NoImg.png"
          alt=""
        />
      </div>
      <el-carousel
        height="230px"
        indicator-position="none"
        class="health-carousel"
      >
        <el-carousel-item
          v-for="(item, index) in healthList"
          :key="index"
          class="carousel-item"
        >
          <div class="content-wrapper">
            <!-- 图片区域（保持原有样式） -->
            <div class="image-area">
              <img
                :src="
                  item.pic_image + '?x-oss-process=image/resize,w_280,m_lfit'
                "
                alt=""
                class="image"
              />
            </div>

            <!-- 新增的统计信息区域 -->
            <div class="stats-area">
              <div class="stats-box">
                <div class="stat-item">
                  <div class="stat-number">{{ month_count }}个</div>
                  <div class="stat-label">30天内到期</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number">{{ week_count }}个</div>
                  <div class="stat-label">提前办理中</div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </ChartBox>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
import { getHealthTable,getHealthcertCount } from "../api/api";
import { baseImgUrl } from "../utils/request";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {
      healthList: [],
      cleanUpMemory: null,
      all_count:'',
      month_count:'',
      week_count:''
    };
  },
  props: {
    // healthList: Array,
    totalCount: Number,
    expiringInWeek: Number,
    expiringInMonth: Number,
    expiredCount: Number,
  },
  mixins: [myMixin],
  components: {
    ChartBox,
  },
  mounted() {
    this.getHealthTable();
    this.getHealthcertCount()
    this.cleanUpMemory = setInterval(() => {
      this.getHealthTable();
    }, 15 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.cleanUpMemory);
  },
  methods: {
    // 健康证信息展示
    async getHealthTable() {
      const res = await getHealthTable({
        order: "desc",
        orderby: "end_date",
      });
      this.healthList = res.data.data[0].data.map((item) => {
        // 判断对象中是否有 pic_image 属性
        if (!item.pic_image?.includes("http")) {
          item.pic_image = baseImgUrl + item.pic_image;
        }
        return item;
      });
    },
    // getHealthcertCount
    async getHealthcertCount() {
      const res = await getHealthcertCount();
      this.week_count = res.data.data.week_count
      this.month_count = res.data.data.month_count
      this.all_count = res.data.data.all_count      
    },
  },
};
</script>

<style lang="scss" scoped>
/* 保持原有样式不变 */
.health-carousel {
  background: transparent;
}

.carousel-item {
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  // display: flex;
  // flex-direction: column;
  // align-content: space-between;
}

.image-area {
  text-align: center;
}

.image {
  width: 100%;
  height: 160px;
  margin-top: 5px;
  object-fit: contain;
  border-radius: 4px;
}

/* 新增统计区域样式 */
.stats-area {
  flex: 1;
  margin-top: 5px;
}

/* 整体统计盒子 */
.stats-box {
  // width: 95%;
  background: rgba(86, 181, 249, 0.1);
  border: 1px solid rgba(86, 181, 249, 0.3);
  border-radius: 6px;
  padding: 2px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
}

/* 每个统计项 */
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 10px;
}

.stat-number {
  font-size: 18px;
  font-weight: bold;
  color: rgb(86, 181, 249);
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}
/* 保持原有样式 */
.desc {
  margin-top: 5px;
}

.tag,
.time {
  font-size: 12px;
  border: 1px solid rgb(86, 181, 249);
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  color: rgb(86, 181, 249);
}

.tag {
  margin-right: 20px;
}

.info {
  color: white;
  font-size: 12px;
  margin-top: 5px;
}

.heaName {
  margin-top: 5px;
}
</style>
